// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/session";

export default function PrivateRoute({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    const next = encodeURIComponent(location.pathname + (location.search || ""));
    return <Navigate to={`/sso?next=${next}`} replace />;
  }
  return children;
}
